import { Chip, useColorScheme, Typography, Tooltip } from "@mui/joy";
import { Divider } from "@mui/material";
import { Box } from "@mui/system";
import { AppConfig } from "../../environement";

/**
 *
 * @returns {ReactElement} FineLineLogo page
 */
export function FineLineLogo() {
  const { mode } = useColorScheme();
  const isDark = mode === "dark";

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
      <img
        style={{ height: 35 }}
        src="https://storage.googleapis.com/films_assets/images/FL-Logo-2026%20circle.png"
      />
      <Typography
        sx={{
          fontFamily: "dharma-gothic-e, sans-serif",
          fontSize: 24,
          color: "#9D2014",
        }}
      >
        FINE LINE
      </Typography>
      {AppConfig.app.alphaWatermark ? (
        <Tooltip
          color="danger"
          size="sm"
          title={
            <Box sx={{ textAlign: "center" }}>
              <b>
                DISCLAIMER: This is the alpha version of the app.
                <br /> It contains bugs and unstable features. <br />
                <u>DO NOT USE OR TRUST</u> any content generated by this version
                <br />
                of the app since it could be inaccurate.
              </b>
            </Box>
          }
        >
          <Chip variant="outlined" size="sm">
            <b>ALPHA</b>
          </Chip>
        </Tooltip>
      ) : (
        <Chip variant="outlined" size="sm">
          {window.app_info.tag}
        </Chip>
      )}
    </Box>
  );
}
